// @flow
import { EventEmitter } from 'events';
import AppDispatcher from './dispatcher';
import FlowController from '../flow-controller';
const CHANGE_EVENT = 'change';

export default class Store extends EventEmitter {
  static updateOrAdd(list, model) {
    list = list.slice();
    const index = _.findIndex(list, { key: model.key });
    if (index !== -1) {
      list[index] = { ...list[index], ...model };
    } else {
      list.push(model);
    }

    return list;
  }

  static addOrReplace(list, model) {
    list = list.slice();
    const index = _.findIndex(list, { key: model.key });
    if (index !== -1) {
      list[index] = model;
    } else {
      list.push(model);
    }

    return list;
  }

  constructor() {
    super();
    this.setMaxListeners(200);
    AppDispatcher.register(this.handleDispatch.bind(this));
    FlowController.addBeforeRender(this);
    this.doEmit = this.doEmit.bind(this);
    this.emitWaiting = false;
  }

  off(event: string, cb: Function): void {
    super.removeListener(event, cb);
  }

  addChangeListener(cb: Function): void {
    this.on(CHANGE_EVENT, cb);
  }

  removeChangeListener(cb: Function): void {
    super.removeListener(CHANGE_EVENT, cb);
  }

  emit(): void {
    this.queued = true;
  }

  doUpdate(): void {
    super.emit(CHANGE_EVENT);
  }

  doEmit(): void {
    this.emitWaiting = false;
    super.emit(CHANGE_EVENT);
  }

  handleDispatch({ type, payload }) {
    if (this._actions[type]) {
      for (var funcName of this._actions[type]) {
        this[funcName](type, payload);
      }
    }
  }
}
